import React from "react";
import { Sparkles } from "lucide-react";

const HeroBadge = ({ children }) => {
  return (
    <div className="inline-flex items-center gap-2 rounded-full bg-blue-100/50 backdrop-blur-sm border border-blue-200 px-4 py-1.5 mb-2 md:mb-6 z-10 hover:scale-105 hover:bg-blue-100 transition-all cursor-default group">
      <Sparkles className="h-4 w-4 text-blue-500 fill-blue-500 animate-pulse group-hover:scale-110 transition-transform" />
      <span className="text-xs sm:text-sm font-bold text-slate-800">
        {children}
      </span>
    </div>
  );
};

export default HeroBadge;
